import Box from '@/assets/icons/Box.svg';
import { Heading } from '@/components/Heading';
import type { CartServiceMessage } from '@/types';
import * as Styled from './InlinedAside.styled';

interface InlinedAsideProps {
  content: CartServiceMessage;
}

export const InlinedAside = ({
  content: { ctaLink, header, messageBody },
}: InlinedAsideProps) => {
  if (!header && !messageBody && !ctaLink) {
    return null;
  }

  return (
    <Styled.Aside>
      <Box />
      <div>
        {header ? <Heading level={3}>{header}</Heading> : null}
        <div
          className="messageBody"
          // biome-ignore lint/security/noDangerouslySetInnerHtml: we trust the source of the HTML
          dangerouslySetInnerHTML={{ __html: messageBody ?? '' }}
        />
        {ctaLink ? (
          <Styled.Cta className="aside-link" href={ctaLink.href ?? ''}>
            {ctaLink.label}
          </Styled.Cta>
        ) : null}
      </div>
    </Styled.Aside>
  );
};
